import { IconCheck } from "@tabler/icons-react";
import {
  Control,
  FieldValues,
  UseFormRegister,
  UseFormWatch,
} from "react-hook-form";

export enum AddUnRegisterContractItemSteps {
  PURCHASE_INFORMATION = "Purchase Information",
  UPLOAD_INVOICE = "Upload Invoice",
  CUSTOMER_INFORMATION = "Customer Information",
  STORE_INFORMATION = "Store Information",
  LINE_ITEM_INFORMATION = "Line Item Information",
  SUCCESS = "Success",
}

export const AddUnRegisterContractSteps = [
  {
    step: 1,
    label: AddUnRegisterContractItemSteps.UPLOAD_INVOICE,
  },
  {
    step: 2,
    label: AddUnRegisterContractItemSteps.PURCHASE_INFORMATION,
  },
  {
    step: 3,
    label: AddUnRegisterContractItemSteps.CUSTOMER_INFORMATION,
  },
  {
    step: 4,
    label: AddUnRegisterContractItemSteps.STORE_INFORMATION,
  },
  {
    step: 5,
    label: AddUnRegisterContractItemSteps.LINE_ITEM_INFORMATION,
  },
  {
    step: 6,
    label: AddUnRegisterContractItemSteps.SUCCESS,
    stepElement: <IconCheck />,
  },
];

export interface StepsProps<FieldsType extends FieldValues> {
  control: Control<FieldsType>;
  register: UseFormRegister<FieldsType>;
  watch: UseFormWatch<FieldsType>;
}
